import React from 'react';
import Layout from '../components/Layout'; // Importa o Layout
import { PageProps } from '../App'; // Importa a interface PageProps

// Adiciona PageProps à definição do componente
const ServicosPage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    // Passa as props para o Layout
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-lupa-orange to-lupa-yellow overflow-hidden">
          {/* ... (restante do código do Hero) ... */}
          <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
                Nossos Serviços
              </h1>
              <p className="mt-6 text-xl text-white/90 max-w-3xl mx-auto">
                Soluções completas para transformar seus dados em vantagem competitiva.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>

        {/* Conteúdo Principal */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-4">Especialistas em Dados e IA</h2>
            <p className="text-xl text-gray-700 dark:text-gray-300 max-w-3xl mx-auto">
              Na Lupa Data, oferecemos um conjunto completo de serviços para ajudar sua empresa a extrair o máximo valor dos seus dados, 
              desde a implementação de infraestrutura até análises avançadas e soluções de IA.
            </p>
          </div>

          {/* Serviços */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Serviço 1 */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
              <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Consultoria em Arquitetura de Dados</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                  Desenvolvemos arquiteturas de dados modernas e eficientes, adaptadas às necessidades específicas do seu negócio. 
                  Nossa equipe de especialistas ajuda a definir a melhor estratégia para centralizar, processar e analisar seus dados.
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Avaliação da infraestrutura atual</span>
                  </div>
                  {/* ... (outros itens da lista) ... */}
                   <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Design de arquitetura de dados</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Roadmap de implementação</span>
                  </div>
                </div>
                <div className="mt-8">
                  <a href="/contato" className="inline-block bg-lupa-orange text-white font-bold py-3 px-6 rounded-lg hover:bg-lupa-orange/90 transition-all duration-300">
                    Saiba mais
                  </a>
                </div>
              </div>
            </div>

            {/* Serviço 2 */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
              <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                </svg>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Implementação de Data Lakes e Data Warehouses</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                  Implementamos soluções completas de armazenamento e processamento de dados, desde data lakes até data warehouses modernos, 
                  utilizando as melhores tecnologias do mercado.
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Implementação de data lakes</span>
                  </div>
                   {/* ... (outros itens da lista) ... */}
                   <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Configuração de data warehouses</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Arquiteturas data lakehouse</span>
                  </div>
                </div>
                <div className="mt-8">
                  <a href="/contato" className="inline-block bg-lupa-orange text-white font-bold py-3 px-6 rounded-lg hover:bg-lupa-orange/90 transition-all duration-300">
                    Saiba mais
                  </a>
                </div>
              </div>
            </div>

            {/* ... (Restante dos serviços) ... */}
             {/* Serviço 3 */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
              <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Ciência de Dados e Analytics</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                  Nossa equipe de cientistas de dados desenvolve modelos analíticos avançados para extrair insights valiosos dos seus dados, 
                  ajudando sua empresa a tomar decisões mais inteligentes e baseadas em evidências.
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Análise exploratória de dados</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Desenvolvimento de dashboards</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Modelos preditivos e prescritivos</span>
                  </div>
                </div>
                <div className="mt-8">
                  <a href="/contato" className="inline-block bg-lupa-orange text-white font-bold py-3 px-6 rounded-lg hover:bg-lupa-orange/90 transition-all duration-300">
                    Saiba mais
                  </a>
                </div>
              </div>
            </div>

            {/* Serviço 4 */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
              <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Desenvolvimento de Soluções de IA</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                  Desenvolvemos soluções personalizadas de Inteligência Artificial para automatizar processos, 
                  melhorar a tomada de decisões e criar vantagens competitivas para o seu negócio.
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Machine Learning aplicado</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Processamento de linguagem natural</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Visão computacional</span>
                  </div>
                </div>
                <div className="mt-8">
                  <a href="/contato" className="inline-block bg-lupa-orange text-white font-bold py-3 px-6 rounded-lg hover:bg-lupa-orange/90 transition-all duration-300">
                    Saiba mais
                  </a>
                </div>
              </div>
            </div>

            {/* Serviço 5 */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
              <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Integração e Migração de Dados</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                  Facilitamos a integração de dados entre diferentes sistemas e plataformas, além de realizar migrações 
                  seguras e eficientes para novas arquiteturas de dados.
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">ETL/ELT personalizado</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Migração para a nuvem</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Integração de sistemas legados</span>
                  </div>
                </div>
                <div className="mt-8">
                  <a href="/contato" className="inline-block bg-lupa-orange text-white font-bold py-3 px-6 rounded-lg hover:bg-lupa-orange/90 transition-all duration-300">
                    Saiba mais
                  </a>
                </div>
              </div>
            </div>

            {/* Serviço 6 */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
              <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                </svg>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Governança de Dados</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                  Ajudamos sua empresa a estabelecer políticas e processos robustos de governança de dados, garantindo 
                  qualidade, segurança, conformidade e uso ético das informações.
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Definição de políticas e padrões</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Gestão da qualidade de dados</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700 dark:text-gray-300">Conformidade com LGPD e outras regulações</span>
                  </div>
                </div>
                <div className="mt-8">
                  <a href="/contato" className="inline-block bg-lupa-orange text-white font-bold py-3 px-6 rounded-lg hover:bg-lupa-orange/90 transition-all duration-300">
                    Saiba mais
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action Final */}
          <div className="mt-20 text-center bg-gray-100 dark:bg-gray-800 p-12 rounded-xl shadow-inner">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-4">Pronto para Impulsionar Seu Negócio com Dados?</h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
              Nossos serviços são projetados para atender às suas necessidades específicas. Entre em contato e descubra como podemos ser seu parceiro estratégico na jornada de dados.
            </p>
            <a href="/contato" className="btn-primary text-lg">
              Fale com Nossos Especialistas
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ServicosPage;
